export const INJECT_VIDEO_LOGO = 'inject video logo';

export interface injectVideoLogoParams {
    videoPath: string
}
export const injectVideoLogo = (params:injectVideoLogoParams) => {
    const { videoPath } = params;
    return {
        type: INJECT_VIDEO_LOGO,
        videoPath,
    };
};
